export default __webpack_public_path__ + "static/media/card4.4032ff13.svg";